import React from 'react';
import { map, sum, capitalize } from 'lodash';
import AbsoluteValue from '../../AbsoluteValue';
import PercentageValue from '../../PercentageValue';
import { splitByThousands, percentageValue } from '../../../../helpers/NumberFormatter';

export const transactionTypeSettings = {
    settingsForTable
};


function settingsForTable(){
    let columns = [

       {
           id: 'source',
           className: 'table-text-left', 
           headerClassName: 'table-text-left',
           Header: 'Source',
           accessor: 'source',
           aggregate: (values, rows) => values[0],
           Aggregated: row => <span>{capitalize(row.value)}</span>,
           Cell: props => <span>{capitalize(props.value)}</span>,
	       Expander: ({ isExpanded, row, ...rest }) => {
	    	   if(row.source == 'Total')
	    		   return null;
	         return <div className={`rt-expander ${isExpanded ? '-open':''}`} />
	       },

           // width: 120
           
       },
       {
           id: 'classification',
           className: 'table-text-left', 
           headerClassName: 'table-text-left',
           Header: 'Classification',
           accessor: 'classification',
           Aggregated: row => {
               return <span>Total</span>
           }
           // aggregate: (values, rows) => values.length
           // width: 120
       },       
                   
       {
           id: 'transaction_type',
           className: 'table-text-left', 
           headerClassName: 'table-text-left',
           Header: 'Transaction Type',
           accessor: 'transaction_type',
           // width: 120
       },
       {
           id: 'total_income',
           className: 'table-text-right', 
           headerClassName: 'table-text-right',
           Header: 'Income',
           // width: 40,
           accessor: 'curr_total_income',
           Cell: props => <PercentageValue field="total_income" item={props.original}></PercentageValue>,
           aggregate: (values, rows) => {
             const totals = rows.reduce((acc, curr) => {
               const row = curr._original;
               if(row) {
                   acc.curr_income += row.curr_total_income;
                   acc.prev_income += row.prev_total_income;
               }
               if(curr._subRows) {
                   for(let subRow of curr._subRows) {
                       const row = subRow._original;
                       console.log(row)
                       if(row) {
                            acc.curr_income += row.curr_total_income;
                            acc.prev_income += row.prev_total_income;
                       }
                   }
               }
               return acc;
             }, { curr_income: 0, prev_income: 0 });
             return totals;
         },
           Aggregated: row => {
        	   const total = row.row.source == 'Total';
               console.log(row.value)
               // const val = Number.parseFloat(row.value).toFixed(2);
               return <span className={total ? 'total-column' : ''}>
                <PercentageValue field="income" item={row.value}></PercentageValue>
               </span>
           }
       },
       {
           id: 'total_quantity',
           className: 'table-text-right', 
           headerClassName: 'table-text-right',
           Header: 'Quantity',
           // width: 40,
           accessor: 'curr_total_quantity',
           Cell: props => <PercentageValue field="total_quantity" item={props.original}></PercentageValue>,
           aggregate: (values, rows) => sum(values),
           Aggregated: row => {
        	   const total = row.row.source == 'Total';
               const val = Number.parseFloat(row.value).toFixed(0);
               return <span className={total ? 'total-column' : ''}>{splitByThousands(row.value)}</span>
           }           
       },
       {
              id: 'pps',
              className: 'table-text-right', 
              headerClassName: 'table-text-right',
              Header: 'PPS',
              // width: 40,
              accessor: 'pps',
              Cell: props => <span>{splitByThousands(props.value, '$')}</span>,
              aggregate: (values, rows) => {
                  const totals = rows.reduce((acc, curr) => {
                    const row = curr._original;
                    if(row) {
                        acc.income += row.curr_total_income;
                        acc.quantity += row.curr_total_quantity;
                    }
                    if(curr._subRows) {
                        for(let subRow of curr._subRows) {
                            const row = subRow._original;
                            if(row) {
                                acc.income += row.curr_total_income;
                                acc.quantity += row.curr_total_quantity;
                            }

                        }
                    }
                    return acc;
                  }, { income: 0, quantity: 0 });
                  const val = totals.quantity ? (totals.income/totals.quantity).toFixed(3) : 0;
                  return val;
                  
              },
              Aggregated: row => {
                  const total = row.row.source == 'Total';
                  return <span className={total ? 'total-column' : ''}>{splitByThousands(row.value, '$')}</span>
              }           
          },

       {
              id: 'share',
              className: 'table-text-right', 
              headerClassName: 'table-text-right',
              Header: 'Share',
              // width: 40,
              accessor: 'share',
              Cell: props => <span>{Number.parseFloat(props.value).toFixed(2)}%</span>,
              aggregate: (values, rows) => sum(values),
              Aggregated: row => {
                  const total = row.row.source == 'Total';
                  return total ? <span className={'total-column'}>100%</span> : <span>{Number.parseFloat(row.value).toFixed(2)}%</span>
              }
          }

    ];
    return columns;
}